const POPUP = {
  AWAITING_OPPONENT: 0,
  DRAW_PROPOSAL_CONFIRM: 1,
  SURRENDER_CONFIRM: 2,
  GAME_OVER_POPUP: 3,
  ERROR_POPUP: 4,
  RULES: 5,
  SETTINGS: 6,
}

export default POPUP
